<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Reports</div>
              <q-select
                label="Type"
                :options="[
                  'Points',
                  'Individual Points',
                  'Results',
                  'Finals Results',
                  'Medals Results',
                  'Media',
                  'Marshalling Sheet',
                  'Rounds',
                  'IRB Top Crews',
                  'Lane Draws',
                  'Liveheats Upload'
                ]"
                v-bind="siteCFG.fields.general"
                dense
                class="q-ml-sm"
                style="width: 150px"
                v-model="reportType"
              >
              </q-select>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadReport"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-download"
                @click="downloadExcelReport"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div class="q-pa-md" v-if="reportType == 'Marshalling Sheet'">
              <q-btn color="primary" @click="downloadExcelReport">
                Download the Marshalling Sheet
              </q-btn>
            </div>
            <div class="q-pa-md" v-if="reportType == 'IRB Top Crews'">
              <q-btn color="primary" @click="downloadExcelReport">
                Download the IRB Top Crews Report
              </q-btn>
            </div>
            <div class="q-pa-md" v-if="reportType == 'Lane Draws'">
              <q-btn color="primary" @click="downloadExcelReport">
                Download the Lane Draws Report
              </q-btn>
            </div>
            <div class="q-pa-md" v-if="reportType == 'Liveheats Upload'">
              <q-btn color="primary" @click="downloadExcelReport">
                Download the Liveheats Upload
              </q-btn>
            </div>
            <div v-if="gridData">
              <div
                class="row q-pa-md"
                v-if="reportTypeLinks[reportType].filters"
              >
                <div class="col-12 col-md-6 q-pa-sm">
                  <autocomplete
                    v-if="reportTypeLinks[reportType].discipline"
                    dense
                    label="Discipline"
                    :items="disciplines"
                    :itemsLoading="disciplinesLoading"
                    option_label="discipline_name"
                    option_value="id"
                    useChips
                    multiple
                    clearable
                    :id="filter.discipline"
                    @changed="
                      val => {
                        filter.discipline = val;
                      }
                    "
                  />
                </div>
                <div class="col-12 col-md-6 q-pa-sm">
                  <autocomplete
                    v-if="reportTypeLinks[reportType].division"
                    dense
                    label="Division"
                    :items="divisions"
                    :itemsLoading="divisionsLoading"
                    option_label="division_name"
                    option_value="id"
                    clearable
                    useChips
                    multiple
                    :id="filter.division"
                    @changed="
                      val => {
                        filter.division = val;
                      }
                    "
                  />
                </div>
                <div class="col-12 col-md-6 q-pa-sm">
                  <autocomplete
                    v-if="reportTypeLinks[reportType].event"
                    dense
                    label="Event"
                    :items="events"
                    :itemsLoading="eventsLoading"
                    option_label="event_name"
                    option_value="id"
                    clearable
                    useChips
                    multiple
                    :id="filter.event"
                    @changed="
                      val => {
                        filter.event = val;
                      }
                    "
                  />
                </div>
                <div class="col-12 col-md-6 q-pa-sm">
                  <autocomplete
                    v-if="reportTypeLinks[reportType].association"
                    dense
                    label="Association"
                    :items="associations"
                    :itemsLoading="associationsLoading"
                    option_label="association_name"
                    option_value="id"
                    clearable
                    useChips
                    multiple
                    :id="filter.association"
                    @changed="
                      val => {
                        filter.association = val;
                      }
                    "
                  />
                </div>
                <div
                  class="col-12 col-md-6 q-pa-sm"
                  v-if="
                    reportTypeLinks[reportType].session &&
                      sessions &&
                      sessions.length > 0
                  "
                >
                  <q-select
                    dense
                    v-bind="siteCFG.fields.general"
                    v-model="filter.currentSession"
                    label="Session"
                    :options="sessions"
                    option-label="name"
                    option-value="id"
                    map-options
                    emit-value
                    :loading="sessionsLoading"
                    clearable
                  >
                    <template v-slot:selected-item="scope">
                      <div style="max-width: 70%" class="ellipsis">
                        <span>
                          {{ scope.opt.name }}
                          <q-chip dense v-if="scope.opt.active" color="orange">
                            Active
                          </q-chip>
                        </span>
                      </div>
                    </template>
                    <template v-slot:option="scope">
                      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                        <q-item-section>
                          <q-item-label>
                            {{ scope.opt.name }}
                            <q-chip
                              dense
                              v-if="scope.opt.active"
                              color="orange"
                            >
                              Active
                            </q-chip>
                          </q-item-label>
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 420px) !important"
                >
                  <component
                    v-bind:is="reportTypeLinks[reportType].component"
                    :search="search"
                    :gridData="gridData"
                  ></component>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="filterDialog" persistent max-width="600px">
      <q-card v-if="filterDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Filter</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="filterDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div class="col-12 col-md-6 q-pa-sm">
              <autocomplete
                dense
                label="Discipline"
                :items="disciplines"
                :itemsLoading="disciplinesLoading"
                option_label="discipline_name"
                option_value="id"
                clearable
                :id="filter.discipline"
                @changed="
                  val => {
                    filter.discipline = val;
                  }
                "
              />
            </div>
            <div class="col-12 col-md-6 q-pa-sm">
              <autocomplete
                dense
                label="Division"
                :items="divisions"
                :itemsLoading="divisionsLoading"
                option_label="division_name"
                option_value="id"
                clearable
                :id="filter.division"
                @changed="
                  val => {
                    filter.division = val;
                  }
                "
              />
            </div>
            <div class="col-12 col-md-6 q-pa-sm">
              <autocomplete
                dense
                label="Event"
                :items="events"
                :itemsLoading="eventsLoading"
                option_label="event_name"
                option_value="id"
                clearable
                :id="filter.event"
                @changed="
                  val => {
                    filter.event = val;
                  }
                "
              />
            </div>
            <div class="col-12 col-md-6 q-pa-sm">
              <autocomplete
                dense
                label="Association"
                :items="associations"
                :itemsLoading="associationsLoading"
                option_label="association_name"
                option_value="id"
                clearable
                :id="filter.association"
                @changed="
                  val => {
                    filter.association = val;
                  }
                "
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
import moment from "moment";
import api from "@/api.js";
import pointsReport from "@/components/reports/pointsReport.vue";
import resultsReport from "@/components/reports/resultsReport.vue";
import mediaReport from "@/components/reports/mediaReport.vue";
import roundsReport from "@/components/reports/roundsReport.vue";
import individualPointsReport from "@/components/reports/individualPointsReport.vue";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    autocomplete,
    pointsReport,
    mediaReport
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "reports/current",
      dataLoading: "reports/currentLoading",
      siteCFG: "settings/siteCFG",
      divisions: "divisions/list",
      divisionsLoading: "divisions/listLoading",
      disciplines: "disciplines/list",
      disciplinesLoading: "disciplines/listLoading",
      events: "events/listForCompetition",
      eventsLoading: "events/listForCompetitionLoading",
      associations: "associations/list",
      associationsLoading: "associations/listLoading",
      sessions: "sessions/listForCompetition",
      sessionsLoading: "sessions/listForCompetitionLoading"
    })
  },
  data: () => ({
    // data-table

    reportType: "Points",

    search: "",

    // Filter
    filter: {
      discipline: null,
      division: null,
      event: null,
      association: null,
      currentSession: null
    },
    filterDialog: false,

    reportTypeLinks: {
      Points: {
        type: "Points",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        component: pointsReport
      },
      "Individual Points": {
        type: "IndividualPoints",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        component: individualPointsReport
      },
      Results: {
        type: "ResultsReport",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        component: resultsReport
      },
      "Finals Results": {
        type: "FinalsResultsReport",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        session: true,
        component: resultsReport
      },
      "Medals Results": {
        type: "MedalsResultsReport",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        session: true,
        component: resultsReport
      },
      Media: {
        type: "MediaReport",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        component: mediaReport
      },
      "Marshalling Sheet": {
        type: "Marshalling Sheet",
        filters: false
      },
      Rounds: {
        type: "RoundsReport",
        filters: true,
        discipline: true,
        division: true,
        event: true,
        association: true,
        component: roundsReport
      },
      "IRB Top Crews": {
        type: "IRBTopCrews",
        filters: false
      },
      "Lane Draws": {
        type: "LaneDraws",
        filters: false
      },
      "Liveheats Upload": {
        type: "FullEntriesList",
        filters: false
      }
    }
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    },
    reportType: function() {
      this.filter = {
        discipline: null,
        division: null,
        event: null,
        association: null,
        currentSession: null
      };
      this.loadReport();
    },
    filter: {
      deep: true,
      handler() {
        this.loadReport();
      }
    }
  },
  mounted() {
    this.$store.dispatch("disciplines/loadAll");
    this.$store.dispatch("divisions/loadAll");
    this.$store.dispatch(
      "events/loadForCompetition",
      this.$route.params.competitions_id
    );
    this.$store.dispatch("associations/loadAll");
    this.$store.dispatch(
      "sessions/loadForCompetition",
      this.$route.params.competitions_id
    );

    this.loadReport();
  },
  methods: {
    handleDoubleClick(row) {
      console.log(row);
    },
    loadReport() {
      let filter = {
        competitions_id: this.$route.params.competitions_id,
        type: this.reportTypeLinks[this.reportType].type,
        discipline: this.filter.discipline,
        division: this.filter.division,
        event: this.filter.event,
        association: this.filter.association,
        currentSession: this.filter.currentSession
      };
      this.$store.dispatch("reports/loadReport", filter);
    },
    downloadExcelReport() {
      if (this.reportType == "Marshalling Sheet") {
        let filter = {
          competitions_id: this.$route.params.competitions_id,
          type: "WavesMarshallingSheet"
        };
        window.open(
          `${api.defaults.baseURL}/report/download?${new URLSearchParams(
            filter
          ).toString()}`,
          "_blank"
        );
      } else if (this.reportTypeLinks[this.reportType].filters == false) {
        let filter = {
          competitions_id: this.$route.params.competitions_id,
          type: this.reportTypeLinks[this.reportType].type
        };

        window.open(
          `${api.defaults.baseURL}/report/download?${new URLSearchParams(
            filter
          ).toString()}`,
          "_blank"
        );
      } else {
        let filter = {
          competitions_id: this.$route.params.competitions_id,
          type: this.reportTypeLinks[this.reportType].type,
          discipline: this.filter.discipline,
          division: this.filter.division,
          event: this.filter.event,
          association: this.filter.association,
          currentSession: this.filter.currentSession
        };

        // Removing Null Values
        filter = Object.fromEntries(
          Object.entries(filter).filter(([_, v]) => v != null)
        );

        window.open(
          `${api.defaults.baseURL}/report/download?${new URLSearchParams(
            filter
          ).toString()}`,
          "_blank"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
